export default __webpack_public_path__ + "static/media/adhesive-tape.3d323440.png";